/* esm.sh - d3-transition@3.0.1/src/transition/style */
export * from "/*d3-transition@3.0.1/esnext/src/transition/style.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/style.mjs";
